"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "wrapPageElement", {
  enumerable: true,
  get: function get() {
    return _botpress["default"];
  }
});
var _botpress = _interopRequireDefault(require("./botpress"));